import { get, post } from "./common/http";
import { BASE_URL } from "./common/const";
import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";

export const GetPurchaseDetail = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Purchase/GetDetail?` + params, null);

export const GetPurchaseByDebit = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Purchase/GetPurchaseByDebit?` + params, null);

export const GetPurchaseList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Purchase/GetList?` + params, null);

export const GetPurchaseDetailDataList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Purchase/GetPurchaseDetailDataList?` + params, null);

export const GetPurchaseAnalysisSummaryList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Purchase/GetPurchaseAnalysisSummaryList?` + params, null);

export const GetPurchaseListBySupplier = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Purchase/GetListBySupplier?` + params, null);

export const CreatePurchase = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Purchase/Create`, data, true);

export const UpdatePurchase = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Purchase/Update`, data, true);

export const DeletePurchase = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Purchase/Delete`, data);

export const LockPurchase = (data: any) =>
  POST_ENC(`${BASE_URL}/api/Purchase/Lock`, data);

export const getPurchaseReportExportFile = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Purchase/PurchaseExportFile?` + params, null);

export const GetPurchaseListForPayment = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Purchase/GetPurchaseListForPayment?` + params, null);

export const GetVoucherNumber = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Purchase/GetVoucherNumber?` + params, null);


export const GetPrintBarcode = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Purchase/GetPrintBarcode?` + params, null);

export const GetAdvancePaymentListForPurchase = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Purchase/GetAdvancePaymentListForPurchase?` + params, null);

export const GetPurchaseSummaryListBySupplier = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Purchase/GetPurchaseSummeryBySupplier?` + params, null)

export const GetPurchaseDetailsListBySupplier = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Purchase/GetPurchaseDetailsBySupplier?` + params, null)

export const GetPurchaseSummaryByProduct = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Purchase/GetPurchaseSummeryByProduct?` + params, null)


export const GetPurchaseDetailsListByProduct = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Purchase/GetPurchaseDetailsByProduct?` + params, null)

export const GetDailyPurchase = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Purchase/GetDailyPurchase?` + params, null)

export const GetPurchaseReturn = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Purchase/GetPurchaseReturn?` + params, null)

export const GetPurchaseOrderDueSummaryList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Purchase/GetPurchaseOrderDueSummaryList?` + params, null)

export const GetPurchaseOrderDueDetailList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Purchase/GetPurchaseOrderDueDetailList?` + params, null)

export const GetPurchaseDetailQtyAdjList = (params: any) =>
   GET_ENC(`${BASE_URL}/api/Purchase/PurchaseDetailQtyAdjList?` + params, null)